export default "__VITE_ASSET__Cgd9Wvme__"